'use client';
import { setAddMany, setToString } from './set.utils.js';

function classNames(s, ...a) {
    return a.forEach((a)=>{
        a && 'object' == typeof a ? Array.isArray(a) ? setAddMany(s, classNames(s, ...a)) : Object.keys(a).forEach((e)=>{
            a[e] && s.add(e);
        }) : a && s.add(a);
    }), s;
}
function className(...e) {
    return setToString(classNames(new Set(), ...e), ' ');
}

export { className, classNames };
